import { render, staticRenderFns } from "./zxlaw.vue?vue&type=template&id=06835932&scoped=true&"
import script from "./zxlaw.vue?vue&type=script&lang=js&"
export * from "./zxlaw.vue?vue&type=script&lang=js&"
import style0 from "./zxlaw.vue?vue&type=style&index=0&id=06835932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06835932",
  null
  
)

export default component.exports